import ClaimStep from "@/components/ClaimStep"
import { defineComponent, type ReactiveComponent } from "vue-utils"

const DisplayCurrentStep: ReactiveComponent = () => {
	return () => (!CurrentStep ? null : <ClaimStep step={CurrentStep} />)
}

export default defineComponent(DisplayCurrentStep)
